import { render, staticRenderFns } from "./ChangeOrders.vue?vue&type=template&id=5cb97b11&lang=pug&"
import script from "./ChangeOrders.vue?vue&type=script&lang=js&"
export * from "./ChangeOrders.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports